import {Grid, Typography} from '@mui/material';
import Lottie from 'lottie-react';
import {bool, string, object, number, node} from 'prop-types';
import * as SpinnerReact from 'spinners-react';
import styled from 'styled-components';

import {FONT_FAMILIES} from '../../const';
import getCompanySpinnerAnimation from '../../img/company-spinner';

const {SpinnerCircular} = SpinnerReact;

const SpinnerAnimation = styled(Lottie)`
  margin: 16px auto;
`;

const Spinner = ({isLoading = false, text = '', textStyle, size = 96, withoutText = false, overrideAnimation = null}) => {
  const animation = overrideAnimation || getCompanySpinnerAnimation();

  if (isLoading) {
    return (
      <Grid data-testid="app-spinner" container alignItems="center" justifyContent="center" direction="column">
        <Grid item>{animation ? <SpinnerAnimation style={{height: size, width: size}} loop animationData={animation} /> : <SpinnerCircular color="#fff" size={size} />}</Grid>
        {!withoutText && (
          <Typography
            sx={{
              fontFamily: FONT_FAMILIES.TITLE,
              textAlign: 'center',
              fontSize: 18,
              marginBottom: 1,
              color: 'text.primary',
              ...textStyle
            }}
            component="div"
            variant="h6"
          >
            {text}
          </Typography>
        )}
      </Grid>
    );
  }
  return null;
};

Spinner.propTypes = {
  isLoading: bool,
  text: string,
  // eslint-disable-next-line react/forbid-prop-types
  textStyle: object,
  size: number,
  // eslint-disable-next-line react/boolean-prop-naming
  withoutText: bool,
  overrideAnimation: node
};

export default Spinner;
